import { css } from '@emotion/react'
import { Color, Size, Spacing, Theme, Typography } from '@opallabs/gem'

export const card = (theme: Theme) =>
  css({
    ...Typography.T500,
    border: `1px solid ${Color[theme].Surface.N300}`,
    borderRadius: Size.Rounding,
    color: Color[theme].Text.Default,
    cursor: 'pointer',
    display: 'inline-block',
    textDecoration: 'none',
    margin: Spacing.XS / 2,
    // 1/2 document width - margins of card
    inlineSize: `calc(50% - ${Spacing.XS}px)`,
    verticalAlign: 'top',
    // Use minimums when parent document is narrow
    minInlineSize: 160,
    minBlockSize: 210,
  })

export const headingWrapper = (theme: Theme) =>
  css({
    padding: Spacing.XS,
    borderBlockEnd: `1px solid ${Color[theme].Surface.N300}`,
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    userSelect: 'none',

    '.embedded-resource-text': {
      color: Color[theme].Text.Default,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },

    '.embedded-resource-icon': {
      marginInlineEnd: Spacing.XS,
    },
  })

export const snapshotWrapper = css({
  display: 'block',
  blockSize: 410,
  inlineSize: '100%',
})

export const snapshot = (isImageLoaded: boolean, theme: Theme) =>
  css({
    backgroundColor: Color[theme].Surface.N100,
    display: isImageLoaded ? 'block' : 'none',
  })

export const snapshotPlaceholder = css({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  blockSize: 'inherit',
  justifyContent: 'center',
  inlineSize: '100%',
})

export const snapshotPlaceholderText = css({
  textAlign: 'center',
  inlineSize: 250,
})
